var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(key, version, requiredVersion) {
	return "Unsatisfied version " + version + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	95042: function() { return loadSingletonVersionCheckFallback("default", "@angular/platform-browser", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_platform-browser___ivy_ngcc___fesm2015_platform-browser_js-_b79c0").then(function() { return function() { return __webpack_require__(/*! @angular/platform-browser */ 71570); }; }); }); },
	23950: function() { return loadSingletonVersionCheckFallback("default", "@angular/core", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_core___ivy_ngcc___fesm2015_core_js-_91cf1").then(function() { return function() { return __webpack_require__(/*! @angular/core */ 2316); }; }); }); },
	46276: function() { return loadSingletonVersionCheckFallback("default", "@ionic/angular", [1,"auto"], function() { return __webpack_require__.e("node_modules_ionic_angular___ivy_ngcc___fesm2015_ionic-angular_js-_ccb20").then(function() { return function() { return __webpack_require__(/*! @ionic/angular */ 7602); }; }); }); },
	66460: function() { return loadSingletonVersionCheckFallback("default", "@angular/common/http", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_common___ivy_ngcc___fesm2015_http_js").then(function() { return function() { return __webpack_require__(/*! @angular/common/http */ 53882); }; }); }); },
	26529: function() { return loadSingletonVersionCheckFallback("default", "rxjs", [1,"auto"], function() { return __webpack_require__.e("node_modules_rxjs__esm2015_index_js-_1b4b1").then(function() { return function() { return __webpack_require__(/*! rxjs */ 67740); }; }); }); },
	70752: function() { return loadSingletonVersionCheckFallback("default", "@ngx-translate/core", [1,"auto"], function() { return __webpack_require__.e("node_modules_ngx-translate_core___ivy_ngcc___fesm2015_ngx-translate-core_js-_8de60").then(function() { return function() { return __webpack_require__(/*! @ngx-translate/core */ 70325); }; }); }); },
	67866: function() { return loadSingletonVersionCheckFallback("default", "@angular/router", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_router___ivy_ngcc___fesm2015_router_js-_feab1").then(function() { return function() { return __webpack_require__(/*! @angular/router */ 71258); }; }); }); },
	90039: function() { return loadSingletonVersionCheckFallback("default", "@angular/common", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_common___ivy_ngcc___fesm2015_common_js-_8c3d1").then(function() { return function() { return __webpack_require__(/*! @angular/common */ 54364); }; }); }); },
	74857: function() { return loadSingletonVersionCheckFallback("default", "@angular/forms", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_forms___ivy_ngcc___fesm2015_forms_js-_2ca81").then(function() { return function() { return __webpack_require__(/*! @angular/forms */ 1707); }; }); }); },
	61087: function() { return loadSingletonVersionCheckFallback("default", "@angular/animations", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_animations___ivy_ngcc___fesm2015_animations_js-_94720").then(function() { return function() { return __webpack_require__(/*! @angular/animations */ 97175); }; }); }); },
	53444: function() { return loadSingletonVersionCheckFallback("default", "@angular/google-maps", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular_google-maps___ivy_ngcc___fesm2015_google-maps_js-_869d0").then(function() { return function() { return __webpack_require__(/*! @angular/google-maps */ 98834); }; }); }); },
	39290: function() { return loadSingletonVersionCheckFallback("default", "angular-svg-icon", [1,"auto"], function() { return __webpack_require__.e("node_modules_angular-svg-icon___ivy_ngcc___fesm2015_angular-svg-icon_js-_99980").then(function() { return function() { return __webpack_require__(/*! angular-svg-icon */ 70459); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"src_bootstrap_ts": [
		95042,
		23950,
		46276,
		66460,
		26529,
		70752,
		67866,
		90039,
		74857,
		61087,
		53444,
		39290
	],
	"node_modules_angular_common___ivy_ngcc___fesm2015_http_js": [
		90039,
		23950,
		26529
	],
	"node_modules_angular_common___ivy_ngcc___fesm2015_common_js-_8c3d0": [
		23950
	],
	"node_modules_angular_core___ivy_ngcc___fesm2015_core_js-_91cf0": [
		26529
	],
	"node_modules_angular_forms___ivy_ngcc___fesm2015_forms_js-_2ca80": [
		23950,
		26529,
		90039
	],
	"node_modules_angular_google-maps___ivy_ngcc___fesm2015_google-maps_js-_869d1": [
		23950,
		90039,
		26529
	],
	"node_modules_angular_platform-browser___ivy_ngcc___fesm2015_platform-browser_js-_b79c1": [
		90039,
		23950
	],
	"node_modules_angular_router___ivy_ngcc___fesm2015_router_js-_feab0": [
		23950,
		26529,
		90039
	],
	"node_modules_ionic_angular___ivy_ngcc___fesm2015_ionic-angular_js-_ccb21": [
		23950,
		74857,
		90039,
		67866,
		26529
	],
	"node_modules_ngx-translate_core___ivy_ngcc___fesm2015_ngx-translate-core_js-_8de61": [
		23950,
		26529
	],
	"node_modules_angular-svg-icon___ivy_ngcc___fesm2015_angular-svg-icon_js-_99981": [
		23950,
		90039,
		26529,
		66460
	],
	"node_modules_angular_core___ivy_ngcc___fesm2015_core_js-_91cf1": [
		26529
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory).catch(onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}